import { get } from 'lodash';
import Axios from 'src/configs/axios';

const FAQ_API = {
  // Categories
  getCategoriesAPI: async () => {
    const response = await Axios.get('/faq/categories');
    const data = get(response, 'data', []);
    return data;
  },

  postCategoryAPI: async (params: Faq.ParamsPostCategory) => {
    const response: any = await Axios.post('/faq/categories', params);
    return response.data;
  },

  updateCategoryAPI: async (params: Faq.ParamsPutCategory) => {
    const response: any = await Axios.put(`/faq/categories/${params.id}`, params);
    return response.data;
  },

  deleteCategoryAPI: async (id: number) => {
    const response: any = await Axios.delete(`/faq/categories/${id}`);
    return response.data;
  },

  // Items
  getItemsAPI: async (params: Faq.ParamsGetItems) => {
    const query = new URLSearchParams(params as any);
    const response = await Axios.get(`/faq/items?${query}`);
    const data = get(response, 'data', null);
    return data;
  },

  postItemAPI: async (params: Faq.ParamsPostItem) => {
    const response: any = await Axios.post('/faq/items', params);
    return response.data;
  },

  updateItemAPI: async (params: Faq.ParamsPutItem) => {
    const response: any = await Axios.put(`/faq/items/${params.id}`, params);
    return response.data;
  },

  deleteItemAPI: async (id: number) => {
    const response: any = await Axios.delete(`/faq/items/${id}`);
    return response.data;
  },
};

export default FAQ_API;
